const STORAGE_KEY = 'lolcator-whats-new-seen';
const DAY_MS = 24 * 60 * 60 * 1000;

// A new entry pops up on its own for this long after its date. Because of
// the expiry, someone who clears their browser data isn't shown old news
// again, and entries never need to be cleaned up for that to work.
export const AUTO_SHOW_DAYS = 30;

// The footer link keeps listing entries a while longer, for people who
// dismissed the popup before reading it.
export const LIST_DAYS = 180;

const ageInDays = ( entry, now ) => {
    return ( now - new Date( `${ entry.date }T00:00:00` ).getTime() ) / DAY_MS;
};

// Entries are expected newest first (see whatsNewEntries.js), but sort anyway
// so a misplaced entry doesn't end up in the wrong place.
const newestFirst = ( a, b ) => b.date.localeCompare( a.date );

export const getRecentEntries = ( entries, now = Date.now() ) => {
    return entries
        .filter( ( entry ) => {
            const age = ageInDays( entry, now );

            return age >= 0 && age <= LIST_DAYS;
        } )
        .sort( newestFirst );
};

export const getEntriesToAutoShow = ( entries, lastSeenId, now = Date.now() ) => {
    return getRecentEntries( entries, now ).filter( ( entry ) => {
        return ageInDays( entry, now ) <= AUTO_SHOW_DAYS && entry.id > lastSeenId;
    } );
};

// Ids are increasing numbers, so remembering the highest one seen is enough:
// anything with a higher id is new. It's a single number, so there's nothing
// to clean up when old entries are removed.
export const readLastSeenId = () => {
    const stored = Number( localStorage.getItem( STORAGE_KEY ) );

    return Number.isFinite( stored ) ? stored : 0;
};

export const markSeen = ( entries ) => {
    const highest = Math.max( readLastSeenId(), ...entries.map( ( entry ) => entry.id ) );

    try {
        localStorage.setItem( STORAGE_KEY, String( highest ) );
    } catch ( error ) {
        // Storage can be full or blocked (private mode) — the popup then
        // shows again next visit, which is harmless.
    }
};
